export const INACTIVITY_TIMEOUT_MS = 60 * 60 * 1000;
export const TOKEN_REFRESH_THRESHOLD_MS = 5 * 60 * 1000;
